module.exports = __webpack_public_path__ + "img/AddAccDB7.5328a312.png";